import { publicPath } from '../vue.config'

import Home from "./pages/Home.vue";

import PageHead from "./pages/PageHead.vue";

import Login from './pages/Login.vue'

import Index from './pages/Index.vue'

import Welcome from './pages/Welcome.vue'

// import CarList from './pages/CarList.vue'
import CarPosition from './pages/CarPosition.vue'

// import DataCenter from './pages/DataCenter.vue'
import DataCenter from './pages/Operations.vue'
import FinancialAnalysis from './pages/FinancialAnalysis.vue'

// 客户端运单列表
import CustomOrderTab from './pages/customer/transOrder/tabpage.vue'
import CustomOrderTobe from './pages/customer/transOrder/tobe.vue'
import CustomOrderIng from './pages/customer/transOrder/ing.vue'
import CustomOrderDone from './pages/customer/transOrder/done.vue'
import CustomOrderView from './pages/customer/transOrder/view.vue'
import CustomOrderViewHire from './pages/customer/transOrder/viewHire.vue'

import ContractOrder from './pages/orderManage/contract/table.vue'
import ContractOrderOwn from './pages/orderManage/contract/own/table.vue'
import ContractOrderOwnTobe from './pages/orderManage/contract/own/tobe/table.vue'
import ContractOrderOwnIng from './pages/orderManage/contract/own/ing/table.vue'
import ContractOrderOwnArrive from './pages/orderManage/contract/own/arrive/table.vue'
import ContractOrderOwnUncheck from './pages/orderManage/contract/own/uncheck/table.vue'
import ContractOrderOwnDone from './pages/orderManage/contract/own/done/table.vue'
import ContractOrderHire from './pages/orderManage/contract/hire/table.vue'
import OrderContractAdd from './pages/orderManage/contract/add.vue'
import OrderContractAddHire from './pages/orderManage/contract/addHire.vue'
import OrderContractDetail from './pages/orderManage/contract/detail.vue'
import OrderContractView from './pages/orderManage/contract/view.vue'
import OrderContractView1 from './pages/orderManage/contract/view1.vue'
import OrderContractView2 from './pages/orderManage/contract/view2.vue'
import OrderContractView3 from './pages/orderManage/contract/view3.vue'
import OrderContractView4 from './pages/orderManage/contract/view4.vue'
import OrderContractView5 from './pages/orderManage/contract/view5.vue'
import OrderContractView41 from './pages/orderManage/contract/view41.vue'

import NonContractOrder from './pages/orderManage/nonContractOrder/table.vue'
import NonContractOrderOwn from './pages/orderManage/nonContractOrder/own/table.vue'
import NonContractOrderOwnTobe from './pages/orderManage/nonContractOrder/own/tobe/table.vue'
import NonContractOrderOwnIng from './pages/orderManage/nonContractOrder/own/ing/table.vue'
import NonContractOrderOwnArrive from './pages/orderManage/nonContractOrder/own/arrive/table.vue'
import NonContractOrderOwnUncheck from './pages/orderManage/nonContractOrder/own/uncheck/table.vue'
import NonContractOrderOwnDone from './pages/orderManage/nonContractOrder/own/done/table.vue'
import NonContractOrderhire from './pages/orderManage/nonContractOrder/hire/table.vue'
import NonContractOrderDetail from './pages/orderManage/nonContractOrder/detail.vue'
import OrderNoContractAdd from './pages/orderManage/nonContractOrder/add.vue'
import OrderNoContractAddHire from './pages/orderManage/nonContractOrder/addHire.vue'
import OrderNoContractView from './pages/orderManage/nonContractOrder/view.vue'
import OrderNoContractView1 from './pages/orderManage/nonContractOrder/view1.vue'
import OrderNoContractView2 from './pages/orderManage/nonContractOrder/view2.vue'
import OrderNoContractView3 from './pages/orderManage/nonContractOrder/view3.vue'
import OrderNoContractView4 from './pages/orderManage/nonContractOrder/view4.vue'
import OrderNoContractView5 from './pages/orderManage/nonContractOrder/view5.vue'
import OrderNoContractView41 from './pages/orderManage/nonContractOrder/view41.vue'
import OrderNoContractFee from './pages/orderManage/nonContractOrder/fee.vue'

import MakeupList from './pages/orderManage/makeup/table.vue'
import Makeupdetail from './pages/orderManage/makeup/detail.vue'
import Makeupedit from './pages/orderManage/makeup/edit.vue'
// 运单回收站
import recycle from './pages/orderManage/recycle/table.vue'

// 合同管理
import ContractList from './pages/contract/manage/table.vue'
// 待接单
import ContractTobeList from './pages/contract/manage/tobe/table.vue'
// 运送中
import ContractIngList from './pages/contract/manage/ing/table.vue'
// 待审核
import ContractUncheckList from './pages/contract/manage/uncheck/table.vue'
// 已完成
import ContractDoneList from './pages/contract/manage/done/table.vue'
// 合同详情
import ContractDetail from './pages/contract/manage/detail.vue'
// 合同附件
import ContractFile from './pages/contract/manage/file.vue'

import ContractOrderList from './pages/contract/manage/orderList/table.vue'
import ContractOrderOwnList from './pages/contract/manage/orderList/own/table.vue'

import ContractOrderAllList from './pages/contract/manage/orderList/all/table.vue'

import ContractMakeup from './pages/contract/makeup/table.vue'
import ContractMakeupDetail from './pages/contract/makeup/detail.vue'
import ContractMakeupEdit from './pages/contract/makeup/edit.vue'

// 客户列表
import Customer from './pages/customer/manage/tabpage.vue'
import CustomerList from './pages/customer/manage/list.vue'
import CustomerDetail from './pages/customer/manage/detail.vue'
import CustomerEdit from './pages/customer/manage/edit.vue'
import CustomerView from './pages/customer/manage/view.vue'
import CustomerKai from './pages/customer/manage/kai.vue'

// 报单管理
import CustomerReportOrder from './pages/customer/reportOrder/table.vue'
import CustomerReportOrderC from './pages/customer/reportOrder/tableCustomer.vue'
import CustomerReportOrderR from './pages/customer/reportOrder/tableRecycle.vue'
import CustomerReportOrderAdd from './pages/customer/reportOrder/add.vue'
import CustomerReportOrderDetail from './pages/customer/reportOrder/detail.vue'

// 操作日志
import CustomerLogList from './pages/customer/log/list.vue'

// 车辆管理
// import Vehicle from './pages/vehicle/manage/table.vue'
import VehicleTeam from './pages/vehicle/manage/team.vue'
import VehicleList from './pages/vehicle/manage/list.vue'
import VehicleList1 from './pages/vehicle/manage/list1.vue'
import VehiclePosition from './pages/vehicle/manage/position.vue'
import VehicleViewTrip from './pages/vehicle/manage/viewTrip.vue'
import VehicleDetail from './pages/vehicle/manage/detail.vue'
import VehicleDocument from './pages/vehicle/manage/document.vue'
import VehicleInsurance from './pages/vehicle/manage/insurance.vue'
import VehicleView from './pages/vehicle/manage/view.vue'
import VehicleViewUrl from './pages/vehicle/manage/viewUrl.vue'
import VehicleGroup from './pages/vehicle/group/table.vue'
import VehicleGroupList from './pages/vehicle/groupList/table.vue'
import VehicleGroupTable from './pages/vehicle/groupList/list.vue'

import VehicleHang from './pages/vehicle/hang/table.vue'
import VehicleHangTab from './pages/vehicle/hang/tabpage.vue'
import VehicleHangDetail from './pages/vehicle/hang/detail.vue'
import VehicleHangView from './pages/vehicle/hang/view.vue'
import Vehicleinspect from './pages/vehicle/inspect/table.vue'
import VehicleinspectDetail from './pages/vehicle/inspect/detail.vue'
import VehicleinspectView from './pages/vehicle/inspect/view.vue'
import VehicleinspectTables from './pages/vehicle/inspect/tables.vue'
// 临期查询
import VehicleDocuments from './pages/vehicle/documents/tabpage.vue'
import VehicleDocumentsList from './pages/vehicle/documents/table.vue'
import VehicleInsuranceList from './pages/vehicle/documents/insuranceTable.vue'
// 违章管理
import BreakRules from './pages/vehicle/breakRules/table.vue'
import BreakRulesList from './pages/vehicle/breakRules/list.vue'
import BreakRulesDetailList from './pages/vehicle/breakRules/detailList.vue'

// 承运管理
import CarrierTab from './pages/carrier/manage/tabpage.vue'
import CarrierList from './pages/carrier/manage/table.vue'
import CarrierCarList from './pages/carrier/manage/gytable.vue'
import CarrierHireCar from './pages/carrier/hirecar/table.vue'
import CarrierCarDetail from './pages/carrier/hirecar/detail.vue'

// 维保管理
import FixList from './pages/fix/manage/table.vue'
import FixdAdd from './pages/fix/manage/add.vue'
import FixdDtail from './pages/fix/manage/detail.vue'
import FixdExamine from './pages/fix/manage/examine.vue'

import FixRepairerList from './pages/fix/repairManage/table.vue'
import FixRepairerDetail from './pages/fix/repairManage/detail.vue'

import FixRepairerTab from './pages/fix/repairer/tab.vue'
import FixRepairer from './pages/fix/repairer/table.vue'
import FixPayment from './pages/fix/repairer/paymentHistory.vue'

// 人员管理
import StaffManager from './pages/staff/manager/tabpage.vue'
import StaffManagerTable from './pages/staff/manager/table.vue'
import StaffManagerDetail from './pages/staff/manager/detail.vue'

import StaffMainAccountant from './pages/staff/mainAccountant/tabpage.vue'
import StaffMainAccountantTable from './pages/staff/mainAccountant/table.vue'
import MainAccountantDetail from './pages/staff/mainAccountant/detail.vue'

import StaffSpecialAccountant from './pages/staff/specialAccountant/tabpage.vue'
import StaffSpecialAccountantTable from './pages/staff/specialAccountant/table.vue'
import SpecialAccountantDetail from './pages/staff/specialAccountant/detail.vue'

import StaffCashier from './pages/staff/cashier/tabpage.vue'
import StaffCashierTable from './pages/staff/cashier/table.vue'
import CashierDetail from './pages/staff/cashier/detail.vue'

import StaffCaptain from './pages/staff/captain/tabpage.vue'
import StaffCaptainTable from './pages/staff/captain/table.vue'
import StaffCaptainDetail from './pages/staff/captain/detail.vue'

import StaffViceCaptain from './pages/staff/viceCaptain/tabpage.vue'
import StaffViceCaptainTable from './pages/staff/viceCaptain/table.vue'
import ViceCaptainDetail from './pages/staff/viceCaptain/detail.vue'

import StaffMaintenance from './pages/staff/maintenance/tabpage.vue'
import StaffMaintenanceTable from './pages/staff/maintenance/table.vue'
import Maintenancedetail from './pages/staff/maintenance/detail.vue'

import StaffVehicleService from './pages/staff/vehicleService/tabpage.vue'
import StaffVehicleServiceTable from './pages/staff/vehicleService/table.vue'
import VehicleServiceDetail from './pages/staff/vehicleService/detail.vue'

// import StaffDriver from './pages/staff/driver/table.vue'
import StaffDriverTeam from './pages/staff/driver/team.vue'
import StaffDriverList from './pages/staff/driver/list.vue'
import StaffDriverDetail from './pages/staff/driver/detail.vue'
// import StaffEscort from './pages/staff/escort/table.vue'
import StaffEscortTeam from './pages/staff/escort/team.vue'
import StaffEscortList from './pages/staff/escort/list.vue'
import StaffEscortDetail from './pages/staff/escort/detail.vue'

import StaffTempDriver from './pages/staff/tempDriver/table.vue'
import TempDriverDetail from './pages/staff/tempDriver/detail.vue'
import StaffTempEscort from './pages/staff/tempEscort/table.vue'
import TempEscortDetail from './pages/staff/tempEscort/detail.vue'

// 考勤管理
import VehicleAttendance from './pages/attendance/vehicle/table.vue'
import AttendanceSummary from './pages/attendance/summary/table.vue'
import DriverAttendance from './pages/attendance/driver/table.vue'
import EscortAttendance from './pages/attendance/escort/table.vue'

// 财务管理
import FinanceFeightStatistics from './pages/finance/feightStatistics/table.vue'
import FinanceShipper from './pages/finance/shipper/table.vue'
import ViewOrder from './pages/finance/shipper/viewOrder.vue'
import ContractFix from './pages/finance/shipper/contractFix.vue'
import PaymentHistory from './pages/finance/shipper/paymentHistory.vue'
import CustomList from './pages/finance/shipper/clist.vue'
import FinanceInitialPayment from './pages/finance/initialPayment/table.vue'
import InitialPaymentDetailList from './pages/finance/initialPayment/tableDetails.vue'
import InitialPaymentRecord from './pages/finance/initialPayment/PaymentRecord.vue'
import InitialAllPaymentRecord from './pages/finance/initialPayment/AllPaymentRecord.vue'
import FinanceCarrier from './pages/finance/carrier/table.vue'
import CarrierOrder from './pages/finance/carrier/carrierOrder.vue'
import CarrierPaymentHistory from './pages/finance/carrier/paymentHistory.vue'

// 合同账款管理
import FinanceAccounts from './pages/finance/accounts/table.vue'
import AccountCarList from './pages/finance/accounts/carList.vue'
import AccountHireCarList from './pages/finance/accounts/hireCarList.vue'
import AccountReceivableOrder from './pages/finance/accounts/receivableOrder.vue'
import AccountPayOrder from './pages/finance/accounts/payOrder.vue'

import FinanceStabilizationFund from './pages/finance/stabilizationFund/table.vue'
import FinanceStabilizationFundList from './pages/finance/stabilizationFund/list.vue'
import FinanceCommissionRecord from './pages/finance/stabilizationFund/commissionRecord.vue'
import FinanceExtractRecord from './pages/finance/stabilizationFund/extractRecord.vue'

// 油气费汇总
import FinanceOilFee from './pages/finance/oilFee/table.vue'
// 现金加油
import FinanceOilFeeCash from './pages/finance/oilFee/cash.vue'
import FinanceOilFeeOrder from './pages/finance/oilFee/order.vue'
import FinanceOilFeeOrderAll from './pages/finance/oilFee/orderAll.vue'
// 油卡加油
import FinanceOilFeeCard from './pages/finance/oilFee/card.vue'
import FinanceOilFeeCardOrder from './pages/finance/oilFee/cardOrder.vue'
import FinanceOilFeeCardOrderAll from './pages/finance/oilFee/cardOrderAll.vue'
// 定点加油
import FinanceOilFeeSite from './pages/finance/oilFee/site.vue'
import FinanceOilFeeStation from './pages/finance/oilFee/station.vue'
import FinanceOilFeeSiteOrder from './pages/finance/oilFee/siteOrder.vue'
import FinanceOilFeeSiteOrderAll from './pages/finance/oilFee/siteOrderAll.vue'

import FinanceFixedFeeList from './pages/finance/fixedFeeList/table.vue'
import FinanceFixedFeeDetailList from './pages/finance/fixedFeeList/detailList.vue'
// import FinanceEstimatedProfit from './pages/finance/estimatedProfit/table.vue'
import FinanceEstimatedProfitList from './pages/finance/estimatedProfit/list.vue'
import FinancemonthOrder from './pages/finance/estimatedProfit/monthOrder.vue'
import FinanceMonthFixRecord from './pages/finance/estimatedProfit/monthFixRecord.vue'
import FinanceCaptainSalary from './pages/finance/captainSalary/table.vue'
import FinancemonthOrderFleet from './pages/finance/captainSalary/monthOrder.vue'
import FinanceMonthFixRecordFleet from './pages/finance/captainSalary/monthFixRecord.vue'
import FinanceExpenseSummary from './pages/finance/expenseSummary/table.vue'
import FinanceExpenseSummaryTableDetails from './pages/finance/expenseSummary/tableDetails.vue'
import FinanceMonthlyStatistical from './pages/finance/monthlyStatistical/table.vue'
import FinanceMonthlyAnalysis from './pages/finance/monthlyAnalysis/table.vue'
import FinanceFleetSummary from './pages/finance/fleetSummary/table.vue'
import FinanceFleetAbnormal from './pages/finance/fleetAbnormal/table.vue'
import FinanceCarrierProfit from './pages/finance/carrierProfit/table.vue'
import FinanceCarrierProfitCarList from './pages/finance/carrierProfit/carList.vue'
import FinanceCarrierProfitAllCarList from './pages/finance/carrierProfit/aLLCarList.vue'
import FinanceCarrierProfitorder from './pages/finance/carrierProfit/order.vue'

// 系统设置
import BaseSalary from './pages/system/baseSalary/table.vue'
import SystemLoginLog from './pages/system/loginLog/table.vue'
import StationConfig from './pages/system/stationConfig/table.vue'
import CargoConfig from './pages/system/cargoConfig/table.vue'
import WarningConfig from './pages/system/warningConfig/table.vue'
import InsuranceConfig from './pages/system/insuranceConfig/table.vue'
import DocumentConfig from './pages/system/documentConfig/table.vue'
import ReminderConfig from './pages/system/reminderConfig/table.vue'
import VehicleTypeConfig from './pages/system/vehicleTypeConfig/table.vue'
import DrivingFee from './pages/system/drivingFee/table.vue'
import FixedFee from './pages/system/fixedFee/table.vue'
import repairConfig from './pages/system/repairConfig/table.vue'
import ExtraFee from './pages/system/extraFee/table.vue'
import Others from './pages/system/others/table.vue'

// 帮助中心
import HelpOperation from './pages/help/operation/table.vue'
import HelpLog from './pages/help/log/list.vue'
import HelpImprove from './pages/help/improve/list.vue'

const routes = [
  { path: '*', redirect: '/admin/welcome' },
  { path: '/login', component: Login },
  { path: '/Indexs', component: Index },
  {
    path: '/admin',
    component: Home,
    redirect: '/admin/index',
    children: [
      { path: 'index', component: Index },
      { path: 'welcome', component: Welcome },
      // { path: 'carposition', component: CarPosition },
      {
        path: 'carposition',
        component: CarPosition,
        redirect: 'carposition/list',
        children: [
          { path: 'list', component: CarPosition }
        ],
      },
      { path: 'dataCenter', component: DataCenter },
      { path: 'financialAnalysis', component: FinancialAnalysis },
    ],
  },
  {
    path: '/reportOrder',
    component: Home,
    redirect: '/reportOrder/list',
    children: [
      // 报单列表
      { path: 'list', component: CustomerReportOrder },
      // 客户端报单列表
      { path: 'clist', component: CustomerReportOrderC },
      // 客户端报单回收站
      { path: 'recyclelist', component: CustomerReportOrderR },
      // 客户端添加报单
      { path: 'add', component: CustomerReportOrderAdd },
      // 报单详情
      { path: 'detail', component: CustomerReportOrderDetail },
      // 客户端详情
      { path: 'cdetail', component: CustomerReportOrderDetail },
      // 报单回收站详情
      { path: 'view', component: CustomerReportOrderDetail },
      // 报单派普通单
      { path: 'dispatch', component: OrderNoContractAdd },
      // 报单派创建合同
      { path: 'addContract', component: ContractDetail },
    ]
  },
  // 客户端运单管理
  {
    path: '/cOrder',
    component: Home,
    redirect: '/cOrder/list',
    children: [
      // 报单列表
      {
        path: 'list',
        component: CustomOrderTab,
        redirect: 'list/tobe',
        children: [
          { path: 'tobe', component: CustomOrderTobe },
          { path: 'ing', component: CustomOrderIng },
          { path: 'done', component: CustomOrderDone },
        ]
      },
      { path: 'view', component: CustomOrderView },
      { path: 'viewHire', component: CustomOrderViewHire },
      
    ]
  },
  // 运单管理
  {
    path: '/order',
    component: Home,
    redirect: '/order/nocontract',
    children: [
      {
        path: 'contract',
        component: ContractOrder,
        redirect: 'contract/own',
        children: [
          {
            path: 'own',
            component: ContractOrderOwn,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: ContractOrderOwnTobe },
              { path: 'ing', component: ContractOrderOwnIng },
              { path: 'arrive', component: ContractOrderOwnArrive },
              { path: 'uncheck', component: ContractOrderOwnUncheck },
              { path: 'done', component: ContractOrderOwnDone },
            ],
          },
          { path: 'hire', component: ContractOrderHire },
        ],
      },
      { path: 'contractposition', component: VehiclePosition },
      { path: 'contractadd', component: OrderContractAdd },
      { path: 'contractAddHire', component: OrderContractAddHire },
      { path: 'contractdetail', component: OrderContractDetail },
      { path: 'contractview', component: OrderContractView },
      { path: 'contractview1', component: OrderContractView1 },
      { path: 'contractview2', component: OrderContractView2 },
      { path: 'contractview3', component: OrderContractView3 },
      { path: 'contractview4', component: OrderContractView4 },
      { path: 'contractview5', component: OrderContractView5 },
      { path: 'contractview41', component: OrderContractView41 },
      // { path: 'contractfee', component: OrderContractFee },
      { path: 'contractfee', component: OrderNoContractFee },
      {
        path: 'nocontract',
        component: NonContractOrder,
        redirect: 'nocontract/own',
        children: [
          {
            path: 'own',
            component: NonContractOrderOwn,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: NonContractOrderOwnTobe },
              { path: 'ing', component: NonContractOrderOwnIng },
              { path: 'arrive', component: NonContractOrderOwnArrive },
              { path: 'uncheck', component: NonContractOrderOwnUncheck },
              { path: 'done', component: NonContractOrderOwnDone },
            ],
          },
          { path: 'hire', component: NonContractOrderhire },
        ],
      },
      { path: 'position', component: VehiclePosition },
      { path: 'nocontractdetail', component: NonContractOrderDetail },
      { path: 'nocontractadd', component: OrderNoContractAdd },
      { path: 'nocontractaddhire', component: OrderNoContractAddHire },
      { path: 'nocontractview', component: OrderNoContractView },
      { path: 'nocontractview1', component: OrderNoContractView1 },
      { path: 'nocontractview2', component: OrderNoContractView2 },
      { path: 'nocontractview3', component: OrderNoContractView3 },
      { path: 'nocontractview4', component: OrderNoContractView4 },
      { path: 'nocontractview5', component: OrderNoContractView5 },
      { path: 'nocontractview41', component: OrderNoContractView41 },
      { path: 'nocontractfee', component: OrderNoContractFee },
      { path: 'makeup', component: MakeupList },
      { path: 'makeupdetail', component: Makeupdetail },
      { path: 'makeupedit', component: Makeupedit },
      { path: 'recycle', component: recycle },
      { path: 'recycleview', component: OrderNoContractView2 },
      { path: 'recyclefee', component: OrderNoContractFee },
    ],
  },
  // 合同管理
  {
    path: '/contract',
    component: Home,
    redirect: '/contract/list',
    children: [
      {
        path: 'list',
        component: ContractList,
        redirect: 'list/tobe',
        children: [
          { path: 'tobe', component: ContractTobeList },
          { path: 'ing', component: ContractIngList },
          { path: 'uncheck', component: ContractUncheckList },
          { path: 'done', component: ContractDoneList },
        ],
      },
      { path: 'addorder', component: OrderContractAdd },
      // 合同管理-数据统计-自有车辆
      { path: 'statistics', component: AccountCarList },
      // 合同管理-数据统计-外协车辆
      { path: 'statistics2', component: AccountHireCarList },
      // 合同管理-数据统计-自有车辆详情
      { path: 'receivableOrder', component: AccountReceivableOrder },
      // 合同管理-数据统计-外协车辆详情
      { path: 'payOrder', component: AccountPayOrder },
      // 合同详情
      { path: 'detail', component: ContractDetail },
      // 合同附件
      { path: 'file', component: ContractFile },
      // 合同订单列表
      {
        path: 'orderlist',
        component: ContractOrderList,
        redirect: 'orderlist/own',
        children: [
          {
            path: 'own',
            component: ContractOrderOwnList,
            redirect: 'own/tobe',
            children: [
              { path: 'tobe', component: ContractOrderOwnTobe },
              { path: 'ing', component: ContractOrderOwnIng },
              { path: 'arrive', component: ContractOrderOwnArrive },
              { path: 'uncheck', component: ContractOrderOwnUncheck },
              { path: 'done', component: ContractOrderOwnDone },
            ],
          },
          { path: 'hire', component: ContractOrderHire },
          { path: 'all', component: ContractOrderAllList },
        ],
      },
      { path: 'orderview', component: OrderContractView },
      { path: 'orderview1', component: OrderContractView1 },
      { path: 'orderview2', component: OrderContractView2 },
      { path: 'orderview3', component: OrderContractView3 },
      { path: 'orderview4', component: OrderContractView4 },
      { path: 'orderview5', component: OrderContractView5 },
      { path: 'orderview41', component: OrderContractView41 },
      // 合同管理-运单列表-自有运单
      { path: 'orderDetail1', component: OrderContractView4 },
      // 合同管理-运单列表-外协运单
      { path: 'orderDetail2', component: OrderContractDetail },
      { path: 'orderFeeDetail', component: OrderNoContractFee },
      { path: 'makeup', component: ContractMakeup },
      { path: 'makeupdetail', component: ContractMakeupDetail },
      { path: 'makeupedit', component: ContractMakeupEdit },
    ],
  },
  // 客户管理
  {
    path: '/customer',
    component: Home,
    redirect: '/customer/manage',
    // redirect: '/customer/list',
    children: [
      {
        path: 'manage',
        component: Customer,
        redirect: 'manage/table/1',
        children: [
          {
            path: 'table',
            component: CustomerList,
          },
          {
            path: 'table/:idx',
            component: CustomerList,
          },
        ],
      },
      { path: 'detail', component: CustomerDetail },
      { path: 'edit', component: CustomerEdit },
      { path: 'view', component: CustomerView },
      { path: 'kai', component: CustomerKai },
      {
        path: 'list',
        component: PageHead,
        redirect: 'list/table',
        children: [
          {
            path: 'table',
            component: CustomerList,
          },
          {
            path: 'detail',
            name: '客户详情',
            component: CustomerDetail,
          },
          {
            path: 'view',
            name: '维护记录',
            component: CustomerView,
          },
          {
            path: 'edit',
            name: '客户编辑',
            component: CustomerEdit,
          },
          {
            path: 'kai',
            name: '发票管理',
            component: CustomerKai,
          },
        ],
      },
      // 报单列表
      { path: 'reportOrder', component: CustomerReportOrder },
      // 客户端报单列表
      { path: 'CReportOrder', component: CustomerReportOrderC },
      // 客户端添加报单
      { path: 'CReportOrderAdd', component: CustomerReportOrderAdd },
      // 报单详情
      { path: 'CReportOrderDetail', component: CustomerReportOrderDetail },
      // 报单派普通单
      { path: 'CReportOrderDispatch', component: OrderNoContractAdd },
      // 报单派创建合同
      { path: 'CReportOrderToContract', component: ContractDetail },
      // 客户管理操作日志
      {
        path: 'log',
        component: PageHead,
        redirect: 'log/table',
        children: [
          {
            path: 'table',
            component: CustomerLogList,
          },
        ],
      },
    ],
  },
  // 车辆管理
  {
    path: '/vehicle',
    component: Home,
    redirect: '/vehicle/manage',
    children: [
      {
        path: 'manage',
        component: VehicleTeam,
        redirect: 'manage/table/1',
        children: [
          // {
          //   path: 'list/:status',
          //   component: VehicleList,
          // },
          {
            path: 'table/1',
            component: VehicleList,
          },
          {
            path: 'table/2',
            component: VehicleList,
          },
          {
            path: 'table/3',
            component: VehicleList1,
          },
        ],
      },
      // {
      //   path: 'manage',
      //   component: Vehicle,
      //   redirect: 'manage/table',
      //   children: [
      //     {
      //       path: 'table',
      //       redirect: 'table/1/list/1',
      //       component: VehicleTeam,
      //       children: [
      //         {
      //           path: 'list',
      //           redirect: 'list/1',
      //           component: VehicleList,
      //         },
      //         {
      //           path: 'list/:status',
      //           component: VehicleList,
      //         },
      //       ],
      //     },
      //     {
      //       path: 'table/:idx',
      //       redirect: 'table/1/list',
      //       component: VehicleTeam,
      //       props: true,
      //       children: [
      //         {
      //           path: 'list',
      //           redirect: 'list/1',
      //           component: VehicleList,
      //         },
      //         {
      //           path: 'list/:status',
      //           component: VehicleList,
      //         },
      //       ],
      //     },
      //   ],
      // },
      { path: 'detail', component: VehicleDetail },
      { path: 'insurance', component: VehicleInsurance },
      { path: 'insurance1', component: VehicleInsurance },
      { path: 'insurance2', component: VehicleInsurance },
      { path: 'document', component: VehicleDocument },
      { path: 'document1', component: VehicleDocument },
      { path: 'document2', component: VehicleDocument },
      { path: 'position', component: VehiclePosition },
      { path: 'viewTrip', component: VehicleViewTrip },
      { path: 'view', component: VehicleView },
      { path: 'viewurl', component: VehicleViewUrl },
      { path: 'group', component: VehicleGroup },
      {
        path: 'groupList',
        component: VehicleGroupList,
        redirect: 'groupList/table/1',
        children: [
          {
            path: 'table/:idx',
            component: VehicleGroupTable,
          },
        ],
      },
      {
        path: 'hang',
        component: VehicleHangTab,
        redirect: 'hang/table/1',
        children: [
          {
            path: 'table/:status',
            component: VehicleHang,
          },
        ],
      },
      { path: 'hangdetail', component: VehicleHangDetail },
      { path: 'hangview', component: VehicleHangView },
      // 违章管理
      {
        path: 'breakRules',
        component: BreakRules,
        redirect: 'breakRules/detailList',
        children: [
          { path: 'detailList', component: BreakRulesDetailList },
          { path: 'list', component: BreakRulesList },
        ],
      },
      {
        path: 'inspect',
        component: Vehicleinspect,
      },
      { path: 'inspectdetail', component: VehicleinspectDetail },
      { path: 'inspectview', component: VehicleinspectView },
      { path: 'inspecttables', component: VehicleinspectTables },
      // 临期查询
      {
        path: 'documents',
        component: VehicleDocuments,
        redirect: 'documents/list',
        children: [
          { path: 'list', component: VehicleDocumentsList },
          { path: 'insurancelist', component: VehicleInsuranceList },
        ],
      },
    ],
  },
  // 承运管理
  {
    path: '/carrier',
    component: Home,
    redirect: '/carrier/manage',
    children: [
      {
        path: 'manage',
        component: CarrierTab,
        redirect: 'manage/table/1',
        children: [
          {
            path: 'table',
            component: CarrierList,
          },
          {
            path: 'table/:idx',
            component: CarrierList,
          },
        ],
      },
      {
        path: 'table',
        component: CarrierList,
      },
      {
        path: 'carlist',
        name: '外协车辆列表',
        component: CarrierCarList,
      },
      {
        path: 'hirecar',
        component: CarrierHireCar,
      },
      {
        path: 'hirecardetail',
        component: CarrierCarDetail,
      },
    ],
  },
  // 维保管理
  {
    path: '/fix',
    component: Home,
    redirect: '/fix/list',
    children: [
      {
        path: 'list',
        // component: FixList,
        component: PageHead,
        redirect: 'list/table',
        children: [
          {
            path: 'table',
            component: FixList,
          },
          {
            path: 'add',
            component: FixdAdd,
            meta: {
              cnname: '添加维保记录',
            },
          },
          {
            path: 'detail',
            component: FixdDtail,
            meta: {
              cnname: '维保记录详情',
            },
          },
          {
            path: 'examine',
            component: FixdExamine,
            meta: {
              cnname: '维保记录详情',
            },
          },
        ],
      },
      // 维修商端-维保列表
      { path: 'repairlist', component: FixRepairerList },
      // 维修商端-维保详情
      { path: 'repairlistadd', component: FixRepairerDetail },
      // 维修商端-维保详情
      { path: 'repairdetail', component: FixRepairerDetail },
      // 机务端-维修商管理审核
      { path: 'repairexamine', component: FixRepairerDetail },
      // 维修商管理
      // { path: 'repairer', component: FixRepairer },
      {
        path: 'repairer',
        component: FixRepairerTab,
        redirect: 'repairer/list',
        children: [
          {
            path: 'list',
            redirect: 'list/1',
            component: FixRepairer,
          },
          {
            path: 'list/:status',
            component: FixRepairer,
          },
        ],
      },
      // 维修商打款记录
      { path: 'payment', component: FixPayment },
      // 管理端维修商打款记录
      { path: 'repairer/payment', component: FixPayment },
      // 管理端维修商订单列表
      { path: 'repairer/orderlist', component: FixRepairerList },
    ],
  },
  // 人员管理
  {
    path: '/staff',
    component: Home,
    redirect: '/staff/manager',
    children: [
      {
        path: 'manager',
        component: StaffManager,
        redirect: 'manager/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffManagerTable,
          },
        ],
      },
      { path: 'managerDetail', component: StaffManagerDetail },
      {
        path: 'mainAccountant',
        component: StaffMainAccountant,
        redirect: 'mainAccountant/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffMainAccountantTable,
          },
        ],
      },
      { path: 'mainAccountantDetail', component: MainAccountantDetail },
      {
        path: 'specialAccountant',
        component: StaffSpecialAccountant,
        redirect: 'specialAccountant/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffSpecialAccountantTable,
          },
        ],
      },
      { path: 'specialAccountantDetail', component: SpecialAccountantDetail },
      {
        path: 'cashier',
        component: StaffCashier,
        redirect: 'cashier/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffCashierTable,
          },
        ],
      },
      { path: 'cashierDetail', component: CashierDetail },
      {
        path: 'captain',
        component: StaffCaptain,
        redirect: 'captain/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffCaptainTable,
          },
        ],
      },
      { path: 'captainDetail', component: StaffCaptainDetail },
      {
        path: 'viceCaptain',
        component: StaffViceCaptain,
        redirect: 'viceCaptain/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffViceCaptainTable,
          },
        ],
      },
      { path: 'viceCaptainDetail', component: ViceCaptainDetail },
      {
        path: 'maintenance',
        component: StaffMaintenance,
        redirect: 'maintenance/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffMaintenanceTable,
          },
        ],
      },
      { path: 'maintenanceDetail', component: Maintenancedetail },
      {
        path: 'vehicleService',
        component: StaffVehicleService,
        redirect: 'vehicleService/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffVehicleServiceTable,
          },
        ],
      },
      { path: 'vehicleServiceDetail', component: VehicleServiceDetail },
      {
        path: 'driver',
        component: StaffDriverTeam,
        redirect: 'driver/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffDriverList,
          },
        ],
      },
      { path: 'driverDetail', component: StaffDriverDetail },
      {
        path: 'escort',
        component: StaffEscortTeam,
        redirect: 'escort/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: StaffEscortList,
          },
        ],
      },
      { path: 'escortDetail', component: StaffEscortDetail },
      { path: 'tempDriver', component: StaffTempDriver },
      { path: 'tempDriverDetail', component: TempDriverDetail },
      { path: 'tempEscort', component: StaffTempEscort },
      { path: 'tempEscortDetail', component: TempEscortDetail },
    ],
  },
  // 考勤管理
  {
    path: '/attendance',
    component: Home,
    redirect: '/attendance/vehicle',
    children: [
      { path: 'vehicle', component: VehicleAttendance },
      { path: 'summary', component: AttendanceSummary },
      { path: 'driver', component: DriverAttendance },
      { path: 'escort', component: EscortAttendance },
    ],
  },
  // 财务管理
  {
    path: '/finance',
    component: Home,
    redirect: '/finance/list',
    children: [
      { path: 'feightStatistics', component: FinanceFeightStatistics },
      { path: 'shipper', component: FinanceShipper },
      { path: 'viewOrder', component: ViewOrder },
      { path: 'contractFix', component: ContractFix },
      { path: 'paymentHistory', component: PaymentHistory },
      // 客户端财务管理
      { path: 'clist', component: CustomList },
      { path: 'initialPayment', component: FinanceInitialPayment },
      { path: 'initialPaymentDetailList', component: InitialPaymentDetailList },
      { path: 'initialFeedetails', component: OrderNoContractFee },
      { path: 'initialPaymentRecord', component: InitialPaymentRecord },
      { path: 'initialAllPaymentRecord', component: InitialAllPaymentRecord },
      { path: 'carrier', component: FinanceCarrier },
      { path: 'carrierOrder', component: CarrierOrder },
      { path: 'carrierPaymentHistory', component: CarrierPaymentHistory },
      {
        path: 'accounts',
        component: FinanceAccounts,
        // component: PageHead,
        // redirect: 'accounts/table',
        // children: [
        //   {
        //     path: 'table',
        //     component: FinanceAccounts,
        //   },
        //   {
        //     path: 'carlist',
        //     name: '车辆列表',
        //     component: AccountCarList,
        //   },
        //   {
        //     path: 'hirecarlist',
        //     name: '车辆列表',
        //     component: AccountHireCarList,
        //   },
        // ],
      },
      {
        path: 'carlist',
        component: AccountCarList,
      },
      {
        path: 'hirecarlist',
        component: AccountHireCarList,
      },
      { path: 'AccountReceivableOrder', component: AccountReceivableOrder },
      { path: 'AccountPayOrder', component: AccountPayOrder },
      {
        path: 'stabilizationFund',
        component: FinanceStabilizationFund,
        redirect: 'stabilizationFund/table/1',
        children: [
          {
            path: 'table/:iswork',
            component: FinanceStabilizationFundList,
          },
        ],
      },
      { path: 'commissionRecord', component: FinanceCommissionRecord },
      { path: 'extractRecord', component: FinanceExtractRecord },
      {
        path: 'oilFee',
        component: FinanceOilFee,
        redirect: 'oilFee/cash',
        children: [
          {
            path: 'cash',
            component: FinanceOilFeeCash,
          },
          {
            path: 'cashorder',
            component: FinanceOilFeeOrder,
          },
          {
            path: 'cashorderall',
            component: FinanceOilFeeOrderAll,
          },
          {
            path: 'card',
            component: FinanceOilFeeCard,
          },
          {
            path: 'cardorder',
            component: FinanceOilFeeCardOrder,
          },
          {
            path: 'cardorderall',
            component: FinanceOilFeeCardOrderAll,
          },
          {
            path: 'site',
            component: FinanceOilFeeSite,
          },
          {
            path: 'station',
            component: FinanceOilFeeStation,
          },
          {
            path: 'siteorder',
            component: FinanceOilFeeSiteOrder,
          },
          {
            path: 'siteorderall',
            component: FinanceOilFeeSiteOrderAll,
          },
        ],
      },
      { path: 'oilfeedetails', component: OrderNoContractFee },
      { path: 'fixedFeeList', component: FinanceFixedFeeList },
      { path: 'fixedFeeDetailList', component: FinanceFixedFeeDetailList },
      {
        path: 'estimatedProfit',
        component: FinanceEstimatedProfitList,
      },
      { path: 'monthorder', component: FinancemonthOrder },
      { path: 'monthfixrecord', component: FinanceMonthFixRecord },
      { path: 'captainSalary', component: FinanceCaptainSalary },
      { path: 'monthorderfleet', component: FinancemonthOrderFleet },
      { path: 'monthfixrecordfleet', component: FinanceMonthFixRecordFleet },
      { path: 'expenseSummary', component: FinanceExpenseSummary },
      { path: 'tabledetails', component: FinanceExpenseSummaryTableDetails },
      { path: 'feedetails', component: OrderNoContractFee },
      { path: 'monthlyStatistical', component: FinanceMonthlyStatistical },
      { path: 'monthlyAnalysis', component: FinanceMonthlyAnalysis },
      { path: 'financeFleetSummary', component: FinanceFleetSummary },
      { path: 'financeFleetAbnormal', component: FinanceFleetAbnormal },
      { path: 'abnormalFee', component: OrderNoContractFee },
      { path: 'carrierProfit', component: FinanceCarrierProfit },
      { path: 'carrierProfitCarList', component: FinanceCarrierProfitCarList },
      { path: 'carrierProfitAllCarList', component: FinanceCarrierProfitAllCarList },
      {
        path: 'carrierProfitOrder',
        component: FinanceCarrierProfitorder,
        // redirect: 'carrierProfitOrder/list',
        // children: [
        //   { path: 'list', component: NonContractOrderhire },
        // ],
      },
      { path: 'carrierProfitOrderDetail', component: OrderNoContractView },
      { path: 'carrierProfitOrderHireDetail', component: NonContractOrderDetail },
    ],
  },
  // 系统设置
  {
    path: '/system',
    component: Home,
    redirect: '/system/reminderConfig',
    children: [
      // 提醒人配置
      { path: 'reminderConfig', component: ReminderConfig },
      // 预警阈值设置
      { path: 'warningConfig', component: WarningConfig },
      // 工资提成设置
      { path: 'baseSalary', component: BaseSalary },
      // 固定费用配置
      { path: 'fixedFee', component: FixedFee },
      // 出车费用配置
      { path: 'drivingFee', component: DrivingFee },
      // 附加费用配置
      { path: 'extraFee', component: ExtraFee },
      // 油气站配置
      { path: 'stationConfig', component: StationConfig },
      // 货物配置
      { path: 'cargoConfig', component: CargoConfig },
      // 车辆类型配置
      { path: 'vehicleTypeConfig', component: VehicleTypeConfig },
      // 车辆保险配置
      { path: 'insuranceConfig', component: InsuranceConfig },
      // 车辆证件配置
      { path: 'documentConfig', component: DocumentConfig },
      // 维保类型配置
      { path: 'repair', component: repairConfig },
      // 基础设置
      { path: 'others', component: Others },
      // 登录日志
      { path: 'loginLog', component: SystemLoginLog },
    ],
  },
  // 帮助中心
  {
    path: '/help',
    component: Home,
    redirect: '/help/operation',
    children: [
      { path: 'operation', component: HelpOperation },
      { path: 'log', component: HelpLog },
      { path: 'improve', component: HelpImprove },
    ],
  },
]

const ROUTE = {
  mode: 'history',
  base: publicPath,
  routes,
}

export default ROUTE